import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/btn_play.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-a727dddc")

_pushScopeId("data-v-a727dddc")
const _hoisted_1 = { class: "detail-video-view" }
const _hoisted_2 = { class: "detail-video-view-video-view" }
const _hoisted_3 = { class: "detail-video-view-seekbar-wrap" }
const _hoisted_4 = {
  class: "detail-video-view-seekbar-out",
  ref: "seekbarOut"
}
const _hoisted_5 = {
  class: "detail-video-view-seekbar-load",
  ref: "seekbarLoad"
}
const _hoisted_6 = {
  class: "detail-video-view-seekbar-in",
  ref: "seekbarIn"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", {
      class: "detail-video-view-video",
      style: { height: _ctx.getHeight() }
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("video", {
          ref: "videoElement",
          class: "detail-video-view-video-area",
          preload: "auto",
          poster: _ctx.imageUrl,
          muted: "",
          controls: "",
          playsinline: "",
          disablePictureInPicture: "",
          controlslist: "nodownload nofullscreen noplaybackrate noremoteplayback"
        }, null, 8, ["poster"]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, null, 512),
            _createVNode("div", _hoisted_6, null, 512)
          ], 512)
        ])
      ])
    ], 4), [
      [_vShow, _ctx.isShowControl()]
    ]),
    _withDirectives(_createVNode("div", {
      class: "detail-video-view-image",
      style: { height: _ctx.getHeight() }
    }, [
      (_ctx.imageUrl)
        ? (_openBlock(), _createBlock("img", {
            key: 0,
            class: "detail-video-view-image-icon",
            src: _ctx.imageUrl
          }, null, 8, ["src"]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode("div", {
        class: "detail-video-view-error-area",
        style: { height: _ctx.getHeight() }
      }, [
        _createVNode("div", {
          class: "detail-video-view-error-text",
          style: { 'line-hight': _ctx.getHeight() }
        }, " 再生できませんでした ", 4)
      ], 4), [
        [_vShow, _ctx.isStateError()]
      ]),
      _withDirectives(_createVNode("img", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.videoPlay(...args))),
        class: "detail-video-view-play-icon",
        src: _imports_0
      }, null, 512), [
        [_vShow, _ctx.isStateNone()]
      ])
    ], 4), [
      [_vShow, !_ctx.isShowControl()]
    ])
  ]))
})